import { ref, inject } from "vue";

export const useStore = () => ({
    patientDeviceSerials: inject("patientDeviceSerials"),
    setPatientDeviceSerials: inject("setPatientDeviceSerials"),

    usageDateRange: inject("usageDateRange"),
    updateUsageDateRange: inject("updateUsageDateRange"),
});

/**
 * @see https://vuejs.org/guide/components/provide-inject.html#app-level-provide
 * @param {App<HostElement = any>} app
 */
export function provideGlobalStoreState(app) {
    patientDeviceSerialsProvider(app);
    usageDateRangeProvider(app);
}

function usageDateRangeProvider(app) {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    let start_date;
    if( urlParams.has('start_date') ){
        start_date = urlParams.get('start_date');
    }

    let end_date;
    if( urlParams.has('end_date') ){
        end_date = urlParams.get('end_date');
    }
    const usageDateRange = ref({ start: start_date, end: end_date });
    function updateUsageDateRange(range) {
        for (let key in range) {
            usageDateRange.value[key] = range[key];
        }
    }
    app.provide('usageDateRange', usageDateRange);
    app.provide('updateUsageDateRange', updateUsageDateRange);
}

function patientDeviceSerialsProvider(app) {
    const patientDeviceSerials = ref([]);
    function setPatientDeviceSerials(serials) {
        patientDeviceSerials.value = serials;
    }
    app.provide("patientDeviceSerials", patientDeviceSerials);
    app.provide("setPatientDeviceSerials", setPatientDeviceSerials);
}
